var _path, _g, _path2, _path3, _path4, _g2, _g3, _g4, _text, _text2, _g5, _g6, _g7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSlider1 = function SvgSlider1(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 920 480"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M6.485 0H920v480H6.485z",
    "data-name": "Rectangle 26524"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    "data-name": "Group 48315"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M191.661 100.406V480",
    "data-name": "Path 45565"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.44 100.406V480",
    "data-name": "Path 45566"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.284 100.406V480",
    "data-name": "Path 45567"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.909 100.406V480",
    "data-name": "Path 45568"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M452.061 100.406V480",
    "data-name": "Path 45569"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M517.686 100.406V480",
    "data-name": "Path 45570"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M583.311 100.406V480",
    "data-name": "Path 45571"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M650.462 100.406V480",
    "data-name": "Path 45572"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M716.087 100.406V480",
    "data-name": "Path 45573"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M772.812 100.406V480",
    "data-name": "Path 45574"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M843.59 100.406V480",
    "data-name": "Path 45575"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M916.015 100.406v336.631",
    "data-name": "Path 45576"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.883 100.406v336.631",
    "data-name": "Path 45577"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#e6e6e6",
    d: "M120.06 271.5h795.132",
    "data-name": "Path 45579"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#e6e6e6",
    d: "M120.06 186.5h795.132",
    "data-name": "Path 45580"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#e6e6e6",
    d: "M120.06 101.5h795.132",
    "data-name": "Path 45581"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 48317"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#e6e6e6",
    d: "M120.06 355.999h795.132",
    "data-name": "Path 45582"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 48318"
  }, /*#__PURE__*/React.createElement("text", {
    fill: "#404040",
    "data-name": "Satisfaction Score",
    fontFamily: "Poppins-Medium, Poppins",
    fontSize: 24,
    fontWeight: 500,
    transform: "rotate(-90 137.437 112.437)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -109.02,
    y: 0
  }, "Satisfaction Score")), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M120.06 100.406v361.336",
    "data-name": "Path 45583"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 48323"
  }, /*#__PURE__*/React.createElement("g", {
    stroke: "#000",
    "data-name": "Group 58427"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M112.699 343.999s41.789-50 70.577-79c26.311-10 35.6-15 69.648-26 27.859-11.333 35.6-8.333 68.72-22.9 34.979-6.766 21.05 1.234 71.506-9.432 39.932-10 23.525-2 69.648-15.667 28.788-2.333 38.384-.667 70.577-7 20.739-4.667 32.5-8 67.791-16 24.764 6.333 42.1 9.667 70.577 16 28.788 15.333 37.765 17 69.648 31 31.265 14.667 32.193 9 67.791 24 33.431 14 73.363 24 73.363 24",
    "data-name": "Path 45596"
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Ellipse 11252",
    transform: "translate(104.343 336)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 8.822,
    cy: 9.5,
    stroke: "none",
    rx: 8.822,
    ry: 9.5
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 8.822,
    cy: 9.5,
    fill: "none",
    rx: 8.322,
    ry: 9
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Ellipse 11253",
    transform: "translate(175.849 257)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 8.822,
    cy: 9.5,
    stroke: "none",
    rx: 8.822,
    ry: 9.5
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 8.822,
    cy: 9.5,
    fill: "none",
    rx: 8.322,
    ry: 9
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Ellipse 11254",
    transform: "translate(243.64 230)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 8.822,
    cy: 9.5,
    stroke: "none",
    rx: 8.822,
    ry: 9.5
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 8.822,
    cy: 9.5,
    fill: "none",
    rx: 8.322,
    ry: 9
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Ellipse 11255",
    transform: "translate(311.43 207)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 8.822,
    cy: 9.5,
    stroke: "none",
    rx: 8.822,
    ry: 9.5
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 8.822,
    cy: 9.5,
    fill: "none",
    rx: 8.322,
    ry: 9
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Ellipse 11256",
    transform: "translate(383.865 198)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 8.822,
    cy: 9.5,
    stroke: "none",
    rx: 8.822,
    ry: 9.5
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 8.822,
    cy: 9.5,
    fill: "none",
    rx: 8.322,
    ry: 9
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Ellipse 11257",
    transform: "translate(452.584 183)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 8.822,
    cy: 9.5,
    stroke: "none",
    rx: 8.822,
    ry: 9.5
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 8.822,
    cy: 9.5,
    fill: "none",
    rx: 8.322,
    ry: 9
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Ellipse 11258",
    transform: "translate(522.233 174)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 8.822,
    cy: 9.5,
    stroke: "none",
    rx: 8.822,
    ry: 9.5
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 8.822,
    cy: 9.5,
    fill: "none",
    rx: 8.322,
    ry: 9
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Ellipse 11259",
    transform: "translate(591.881 160)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 8.822,
    cy: 9.5,
    stroke: "none",
    rx: 8.822,
    ry: 9.5
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 8.822,
    cy: 9.5,
    fill: "none",
    rx: 8.322,
    ry: 9
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Ellipse 11260",
    transform: "translate(663.386 176)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 8.822,
    cy: 9.5,
    stroke: "none",
    rx: 8.822,
    ry: 9.5
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 8.822,
    cy: 9.5,
    fill: "none",
    rx: 8.322,
    ry: 9
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Ellipse 11261",
    transform: "translate(733.963 207)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 8.822,
    cy: 9.5,
    stroke: "none",
    rx: 8.822,
    ry: 9.5
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 8.822,
    cy: 9.5,
    fill: "none",
    rx: 8.322,
    ry: 9
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Ellipse 11262",
    transform: "translate(800.826 230)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 8.822,
    cy: 9.5,
    stroke: "none",
    rx: 8.822,
    ry: 9.5
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 8.822,
    cy: 9.5,
    fill: "none",
    rx: 8.322,
    ry: 9
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Ellipse 11263",
    transform: "translate(869.545 254)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 8.822,
    cy: 9.5,
    stroke: "none",
    rx: 8.822,
    ry: 9.5
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 8.822,
    cy: 9.5,
    fill: "none",
    rx: 8.322,
    ry: 9
  }))), /*#__PURE__*/React.createElement("g", {
    stroke: "#f1ad0f",
    "data-name": "Group 48320"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M111.483 313s39.75-32 73.028-56c22.186-16 32.354-23 69.331-42 32.354-17.667 29.581-9 67.482-30 38.209-11 20.337-5.667 70.255-15.667 16.947-5.333 50.855-12.685 69.331-16.666 21.261-7 48.609-15.416 69.639-24.334 30.2-1.333 41.291.667 70.255 1.667 25.883 12 24.959 15 69.331 38.333 23.727 8 31.739 21 69.947 29.667 38.209 8 21.261 2.667 72.1 11 30.505 5 62.86 7.333 62.86 7.333",
    "data-name": "Path 45614"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#f1ad0f",
    "data-name": "Ellipse 11240",
    transform: "translate(104.485 302)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 9.5,
    cy: 9.5,
    r: 9.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 9.5,
    cy: 9.5,
    r: 9,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#f1ad0f",
    "data-name": "Ellipse 11241",
    transform: "translate(176.485 250)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 9.5,
    cy: 9.5,
    r: 9.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 9.5,
    cy: 9.5,
    r: 9,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#f1ad0f",
    "data-name": "Ellipse 11242",
    transform: "translate(243.959 207)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 9.5,
    cy: 9.5,
    r: 9.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 9.5,
    cy: 9.5,
    r: 9,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#f1ad0f",
    "data-name": "Ellipse 11243",
    transform: "translate(312.311 176)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 9.5,
    cy: 9.5,
    r: 9.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 9.5,
    cy: 9.5,
    r: 9,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#f1ad0f",
    "data-name": "Ellipse 11244",
    transform: "translate(381.586 160)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 9.5,
    cy: 9.5,
    r: 9.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 9.5,
    cy: 9.5,
    r: 9,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#f1ad0f",
    "data-name": "Ellipse 11245",
    transform: "translate(450.861 144)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 9.5,
    cy: 9.5,
    r: 9.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 9.5,
    cy: 9.5,
    r: 9,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#f1ad0f",
    "data-name": "Ellipse 11246",
    transform: "translate(521.06 120)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 9.5,
    cy: 9.5,
    r: 9.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 9.5,
    cy: 9.5,
    r: 9,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#f1ad0f",
    "data-name": "Ellipse 11247",
    transform: "translate(591.259 121)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 9.5,
    cy: 9.5,
    r: 9.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 9.5,
    cy: 9.5,
    r: 9,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#f1ad0f",
    "data-name": "Ellipse 11248",
    transform: "translate(661.458 159)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 9.5,
    cy: 9.5,
    r: 9.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 9.5,
    cy: 9.5,
    r: 9,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#f1ad0f",
    "data-name": "Ellipse 11249",
    transform: "translate(717.047 187)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 9.5,
    cy: 9.5,
    r: 9.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 9.5,
    cy: 9.5,
    r: 9,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#f1ad0f",
    "data-name": "Ellipse 11250",
    transform: "translate(793.047 199)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 9.5,
    cy: 9.5,
    r: 9.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 9.5,
    cy: 9.5,
    r: 9,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#f1ad0f",
    "data-name": "Ellipse 11251",
    transform: "translate(860.047 206)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 9.5,
    cy: 9.5,
    r: 9.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 9.5,
    cy: 9.5,
    r: 9,
    fill: "none"
  }))), /*#__PURE__*/React.createElement("g", {
    fill: "#7b7b7b",
    "data-name": "Group 48333"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m911.305 279.97-6.919-.923v-1.582a8.93 8.93 0 0 0 5.427-8.205v-4.286a5.038 5.038 0 0 0-2.714-9.284.775.775 0 0 0-.775.775 1.55 1.55 0 0 1-1.55 1.55h-8.47a4.327 4.327 0 0 0-4.323 4.323v6.919a8.91 8.91 0 0 0 5.427 8.208v1.583l-6.919.923a5.44 5.44 0 0 0-4.709 5.379v9.107a.775.775 0 0 0 .775.775h28.684a.775.775 0 0 0 .775-.775v-9.108a5.44 5.44 0 0 0-4.709-5.379m-17.774-17.629a2.776 2.776 0 0 1 2.772-2.772h8.469a3.1 3.1 0 0 0 2.986-2.261 3.49 3.49 0 0 1-.66 6.916H893.53Zm0 6.919v-3.489h13.568a5 5 0 0 0 1.164-.136v3.626a7.366 7.366 0 0 1-14.731 0Zm8.77 24.421h-9.545v-12.449l2.539-.339c.408.742 6.6 12.043 7.006 12.787Zm-14.972-8.332a3.89 3.89 0 0 1 3.364-3.841l.512-.069v12.242h-3.876Zm16.743 8.332-2.126-3.873h2.826a1.939 1.939 0 1 1 0 3.878Zm10.394 0h-6.794a3.49 3.49 0 0 0-2.9-5.428h-3.676l-4.152-7.581 1.342-.178a.775.775 0 0 0 .673-.769v-1.762a8.95 8.95 0 0 0 3.876 0v1.766a.775.775 0 0 0 .673.769l7.592 1.01a3.886 3.886 0 0 1 3.364 3.841Z",
    "data-name": "Path 45608"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M897.407 268.096h-.775a.775.775 0 0 0 0 1.55h.775a.775.775 0 0 0 0-1.55",
    "data-name": "Path 45609"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M904.386 269.646h.775a.775.775 0 0 0 0-1.55h-.775a.775.775 0 0 0 0 1.55",
    "data-name": "Path 45610"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M900.89 274.297a3.05 3.05 0 0 0 2.079-.822.774.774 0 0 0 .053-1.095.783.783 0 0 0-1.1-.047 1.47 1.47 0 0 1-1.016.412 1.65 1.65 0 0 1-1.037-.419.775.775 0 1 0-1.042 1.148 3.17 3.17 0 0 0 2.066.822Z",
    "data-name": "Path 45611"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#7b7b7b",
    "data-name": "Group 48334"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M912.744 205.059a.9.9 0 1 1-1.793 0 .9.9 0 1 1 1.793 0",
    "data-name": "Path 45612"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M911.844 201.852a3.21 3.21 0 0 0-3.051 2.243h-.792a2.864 2.864 0 0 0-2.857 2.865v12.191a5.111 5.111 0 1 1-10.222 0v-3.856a7.48 7.48 0 0 0 6.287-5.834l1.589-7.6a3.6 3.6 0 0 0-3.042-4.266 2.334 2.334 0 1 0-.038 1.947 1.667 1.667 0 0 1 1.2 1.929l-1.589 7.6a5.481 5.481 0 0 1-10.733 0l-1.589-7.6a1.666 1.666 0 0 1 1.2-1.929 2.334 2.334 0 1 0-.047-1.947 3.6 3.6 0 0 0-3.039 4.272l1.589 7.6a7.48 7.48 0 0 0 6.287 5.828v3.855a7.032 7.032 0 1 0 14.064 0v-12.19a.94.94 0 0 1 .938-.94h.792a3.2 3.2 0 1 0 3.053-4.168m0 5.13a1.923 1.923 0 1 1 1.921-1.923 1.924 1.924 0 0 1-1.921 1.923",
    "data-name": "Path 45613"
  })))), _text || (_text = /*#__PURE__*/React.createElement("text", {
    "data-name": "Average Satisfaction Scores",
    fontFamily: "Poppins-Bold, Poppins",
    fontSize: 34,
    fontWeight: 700,
    transform: "translate(1.873 36)"
  }, /*#__PURE__*/React.createElement("tspan", {
    xmlSpace: "preserve",
    x: 0,
    y: 0
  }, " Average Satisfaction Scores"))), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    fill: "#666",
    "data-name": "Source: E2E Internal Healthcare Research",
    fontFamily: "Poppins-Regular, Poppins",
    fontSize: 20,
    transform: "translate(5.703 70)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Source: E2E Internal Healthcare Research"))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 48328"
  }, /*#__PURE__*/React.createElement("text", {
    "data-name": "Data Collected in 12 Waves",
    fontFamily: "Poppins-Medium, Poppins",
    fontSize: 17,
    fontWeight: 500,
    transform: "translate(417.485 474)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Data Collected in 12 Waves")))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    fill: "#333",
    "data-name": "Group 48331",
    fontFamily: "Poppins-Regular, Poppins",
    fontSize: 18
  }, /*#__PURE__*/React.createElement("text", {
    transform: "translate(153.486 396.598)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -16.209,
    y: 0
  }, "Jan")), /*#__PURE__*/React.createElement("text", {
    transform: "translate(225.304 396.598)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -16.245,
    y: 0
  }, "Feb")), /*#__PURE__*/React.createElement("text", {
    transform: "translate(285.408 396.598)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -17.19,
    y: 0
  }, "Mar")), /*#__PURE__*/React.createElement("text", {
    transform: "translate(352.365 396.598)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -15.48,
    y: 0
  }, "Apr")), /*#__PURE__*/React.createElement("text", {
    transform: "translate(417.452 396.598)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -18.819,
    y: 0
  }, "May")), /*#__PURE__*/React.createElement("text", {
    transform: "translate(482.586 396.598)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -15.849,
    y: 0
  }, "Jun")), /*#__PURE__*/React.createElement("text", {
    transform: "translate(549.329 396.598)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -12.195,
    y: 0
  }, "Jul")), /*#__PURE__*/React.createElement("text", {
    transform: "translate(614.574 396.598)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -17.73,
    y: 0
  }, "Aug")), /*#__PURE__*/React.createElement("text", {
    transform: "translate(680.432 396.598)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -16.794,
    y: 0
  }, "Sep")), /*#__PURE__*/React.createElement("text", {
    transform: "translate(747.509 396.598)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -16.065,
    y: 0
  }, "Oct")), /*#__PURE__*/React.createElement("text", {
    transform: "translate(806.043 396.598)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -17.163,
    y: 0
  }, "Nov")), /*#__PURE__*/React.createElement("text", {
    transform: "translate(877.508 396.598)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -17.658,
    y: 0
  }, "Dec")), /*#__PURE__*/React.createElement("text", {
    "data-name": "(W1)",
    transform: "translate(153.486 429.598)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -18.252,
    y: 0
  }, "(W1)")), /*#__PURE__*/React.createElement("text", {
    "data-name": "(W2)",
    transform: "translate(223.486 429.598)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -20.772,
    y: 0
  }, "(W2)")), /*#__PURE__*/React.createElement("text", {
    "data-name": "(W3)",
    transform: "translate(284.43 429.598)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -20.97,
    y: 0
  }, "(W3)")), /*#__PURE__*/React.createElement("text", {
    "data-name": "(W4)",
    transform: "translate(352.544 429.598)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -21.249,
    y: 0
  }, "(W4)")), /*#__PURE__*/React.createElement("text", {
    "data-name": "(W5)",
    transform: "translate(418.818 429.598)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -21.213,
    y: 0
  }, "(W5)")), /*#__PURE__*/React.createElement("text", {
    "data-name": "(W6)",
    transform: "translate(484.17 429.598)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -21.258,
    y: 0
  }, "(W6)")), /*#__PURE__*/React.createElement("text", {
    "data-name": "(W7)",
    transform: "translate(552.292 429.598)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -20.223,
    y: 0
  }, "(W7)")), /*#__PURE__*/React.createElement("text", {
    "data-name": "(W8)",
    transform: "translate(616.717 429.598)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -21.294,
    y: 0
  }, "(W8)")), /*#__PURE__*/React.createElement("text", {
    "data-name": "(W9)",
    transform: "translate(682.07 429.598)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -21.141,
    y: 0
  }, "(W9)")), /*#__PURE__*/React.createElement("text", {
    "data-name": "(W10)",
    transform: "translate(747.27 429.598)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -23.778,
    y: 0
  }, "(W10)")), /*#__PURE__*/React.createElement("text", {
    "data-name": "(W11)",
    transform: "translate(806.048 429.598)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -20.835,
    y: 0
  }, "(W11)")), /*#__PURE__*/React.createElement("text", {
    "data-name": "(W12)",
    transform: "translate(877.048 429.598)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -23.355,
    y: 0
  }, "(W12)")))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    fill: "#333",
    "data-name": "Group 48332",
    fontFamily: "Poppins-Regular, Poppins",
    fontSize: 18
  }, /*#__PURE__*/React.createElement("text", {
    "data-name": "50%",
    transform: "translate(94.486 360)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -34.002,
    y: 0
  }, "50%")), /*#__PURE__*/React.createElement("text", {
    "data-name": "65%",
    transform: "translate(94.486 275.999)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -34.128,
    y: 0
  }, "65%")), /*#__PURE__*/React.createElement("text", {
    "data-name": "80%",
    transform: "translate(94.486 193)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -34.164,
    y: 0
  }, "80%")), /*#__PURE__*/React.createElement("text", {
    "data-name": "95%",
    transform: "translate(94.486 109)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -33.894,
    y: 0
  }, "95%")))));
};
export default SvgSlider1;